import $ from 'jquery';
import { isMobile } from './Utils';

export default class ImageCreditsController {
    static createForElement(e) {
        let title = e.getAttribute('title');
        if (title === undefined || title === '') return;
        title = `&copy; ${title}`;
        e.removeAttribute('title');
        const wrapper = document.createElement('div');
        wrapper.classList.add('image-credits-wrapper');

        e.parentNode.insertBefore(wrapper, e);
        wrapper.appendChild(e);
        const credits = document.createElement('div');
        credits.classList.add('image-credits');
        const creditsText = document.createElement('div');
        creditsText.innerHTML = title;
        creditsText.classList.add('image-credits-text');
        creditsText.classList.add('credits-hidden');
        credits.appendChild(creditsText);
        const image = document.createElement('img');
        image.src = '/App_Themes/sos/images/photo-camera.png';
        image.classList.add('image-credits-button');
        image.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            creditsText.classList.toggle('credits-hidden');
        });
        if (!isMobile()) {
            image.addEventListener('mouseover', () => {
                creditsText.classList.remove('credits-hidden');
            });
            image.addEventListener('mouseout', () => {
                creditsText.classList.add('credits-hidden');
            });
        }
        credits.appendChild(image);
        wrapper.appendChild(credits);
    }

    static init() {
        const elements = document.querySelectorAll('img[title]');
        elements.forEach((e) => {
            ImageCreditsController.createForElement(e);
        });
    }
}

$(() => {
    ImageCreditsController.init();
});
